// Small utils — ported from eb-ui creator-collections-listing `src/_shared/utils.ts`.
import type { ServerData, Collection } from '@/types';
import { CollectionStatus } from '@/types';
import { AUTOCREATED_COLLECTION_DEFAULT_NAME } from './constants';

/**
 * Whether the card should hide the "organizer info" signal (i.e. the card is from
 * the SAME organizer as the page owner). Preserved from the eb-ui source verbatim.
 */
export const initSignalProp = (
    pageOwnerOrganizerId: string,
    cardOrganizerId?: string,
): { signal?: undefined } | Record<string, never> => {
    const shouldShowOrganizerInfo = pageOwnerOrganizerId !== cardOrganizerId;
    return shouldShowOrganizerInfo ? {} : { signal: undefined };
};

export const isAutocreatedCollectionUnedited = (collection?: Collection): boolean => {
    if (!collection) {
        return false;
    }
    return Boolean((
        collection.is_autocreated &&
        collection.name === AUTOCREATED_COLLECTION_DEFAULT_NAME &&
        collection.summary === '' &&
        collection.status === CollectionStatus.Draft
    ));
};

export const isAutocreatedCollectionPreviewWithTips = (
    context: ServerData | null,
): boolean => {
    return Boolean(
        (context as { request?: { params?: Record<string, unknown> } })?.request?.params
            ?.autocreated === 'true'
    );
};
